export default __webpack_public_path__ + "static/media/mons13.f42ced17.jpg";